import React from 'react';
import PropTypes from 'prop-types';
import { Card, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { fNumber } from 'utils/formatNumber';
import { fDateTime } from 'utils/formatTime';
import Iconify from 'components/Iconify';
import Label from 'components/Label';
import { useTheme } from '@mui/material/styles';
import OrderTimelineView from './OrderTimelineView';
import OrderEventTimeline from './OrderEventTimeline';

const GiftcardOderDetails = ({order,bank,events}) => {
    const theme = useTheme();
    
    let color = (order.status === 'cancelled' && 'error') || 'secondary';
        if(order.status === "completed"){
            color = 'success';
        } else if(order.status === "processing"){
            color = 'primary';
        }
        else if(order.status === "submitted"){
            color = 'warning';
        }
    return <>

        <Card sx={{padding:3, mb:3}}>
            <Typography variant="h6" component="p" sx={{mb:3}}>
            Settlement Bank Details
            </Typography>
            <Typography variant="subtitle2" component="p" color="textSecondary">
            {bank?.bank_name}
            </Typography>
            <Typography variant="subheading" component="p" color="textSecondary">
            Account name: {bank?.account_name}
            </Typography>
            <Typography variant="subheading" component="p" color="textSecondary">
            Account number: {bank?.account_number}
            </Typography>
        </Card>
        <Card sx={{padding:3}}>
            <Typography variant="h6" component="p" sx={{mb:3}}>
                Order details
            </Typography>
            <TableContainer >
                <Table>
                    <TableBody>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    User
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    <Iconify icon={'ph:user-thin'} size="small" sx={{width:18,height:18,mr:1, mt:1}} />
                                    {order.first_name} {order.last_name}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Order I.D
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    #{String(order.order_id).toLocaleUpperCase()}

                                    <Label sx={{ml:3}}
                                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                        color={color} >
                                        {String(order.status).toLocaleUpperCase()}
                                    </Label>
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                                <TableCell >
                                    <Typography variant="subtitle2" noWrap>
                                        Amount
                                    </Typography>
                                </TableCell>
                                <TableCell >
                                    <Typography variant="subtitle2" noWrap>
                                        {order.currency}{fNumber(order.amount * order.number_of_cards)}
                                    </Typography>
                                </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Settlement amount
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    NGN{fNumber(order.settlement_amount)}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Category
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    {order.category} - {order.type_name} -- {order.country}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        {/* <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Sub-category
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    {order.sub_category}
                                </Typography>
                            </TableCell>
                        </TableRow> */}
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Stake
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    NGN{order.stake}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Rate
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    {order.rate}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    # Comment
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    {order.user_remark ?? ""}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Channel
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    {order.channel}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Channel Rate
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    {order.channel_rate}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        
                        
                        
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Updated at
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    {fDateTime(order.updated_at)}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}  >
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    Created at
                                </Typography>
                            </TableCell>
                            <TableCell >
                                <Typography variant="subtitle2" noWrap>
                                    {fDateTime(order.created_at)}
                                </Typography>
                            </TableCell>
                        </TableRow>
                      
                    </TableBody>
                </Table>
            </TableContainer>
        </Card>
        </>
};

GiftcardOderDetails.propTypes = {
    order: PropTypes.object,
    bank: PropTypes.object,
    events: PropTypes.array,
}
export default GiftcardOderDetails;